<template>
    <div ref="upload-box">
        <div class="cb">
            <span class="line fl"></span>
            <span class="fl">
                <span :class="`dc${is_first ? '' : ' cp'}`" @click="back">上传视频</span>
                <span v-show="!is_first" class="rgt">&gt;</span>
                <span v-show="!is_first"> 填写视频信息</span>
            </span>
        </div>
        <div v-if="is_first" :class="`upload-box${is_drag ? ' file-drag' : ''}`" @drop.prevent="drop" @dragover.prevent @dragenter.prevent="is_drag = true" @dragleave="dragleave">
            <label class="upload-button bg" for="upload">
                <div class="upload-icon"></div>
                上传视频
            </label>
            <input type="file" id="upload" class="dn" accept="video/*" @change="change">
            <div class="upload-tip">{{is_drag ? '松开鼠标上传该文件' : '拖拽视频到此处也可上传'}}</div>
            <p class="upload-rule">
                上传视频，即表示您已同意
                <router-link class="upload-link" to="upload/norm">唯舞视频投稿协议</router-link>
                <br>
                视频最大支持300M，时长需5秒以上，10分钟以下，分辨率超过360P
                <router-link class="upload-link" to="upload/norm">常见问题</router-link>
            </p>
        </div>

        <div v-if="!is_first" class="edit-box pr">
            <div v-show="is_loading || is_drafting" class="loading-mask"></div>
            <div class="video-box">
                <img class="cover" :src="cover || imgs[checkIdx]" alt="">
                <div class="video-info">
                    {{this.protoTitle}}
                    <div v-show="is_uploading" class="bar-box">
                        <div class="bar pr">
                            <div :style="`transform: translateX(-${100 - uploadProgress}%)`" class="progress"></div>
                        </div>
                        {{uploadProgress}}%
                    </div>
                    <div v-show="is_uploaded" class="uploaded-box">
                        <i class="icon-success"></i>
                        视频上传成功!
                    </div>
                </div>
            </div>
            <div class="cover-box pr">
                <div class="tri"></div>
                <div class="cover-list-box">
                    <label for="upload-cover" :class="`cover-list cover-text cp${cover_drag ? ' cover-drag' : ''}`" @drop.prevent="coverDrop" @dragover.prevent @dragenter.prevent="cover_drag = true" @dragleave="cover_drag = false">
                        上传自定义封面
                    </label>
                    <input @change="coverChange" ref="coverInput" type="file" id="upload-cover" class="dn" accept="image/png,image/jpg,image/jpeg">
                    <div v-for="k in 4" :key="k" :class="`cover-list${imgs[k - 1] ? ' cp' : ''}`">
                        <div class="cover-checked" v-show="k - 1 === checkIdx">
                            <div class="cover-checked-icon">
                                <i class="icon-success"></i>
                            </div>
                        </div>
                        <div class="cover-mask" v-show="k - 1 !== checkIdx && imgs[k - 1]" @click="checkCover(k - 1)" title="设置本图片为视频封面">
                            设为封面
                        </div>
                        <img class="cover-img" :src="imgs[k - 1] || 'https://img.vhiphop.com/web/loading-2.gif'" alt="">
                    </div>
                </div>
                <div class="cover-tip">
                    <span>建议上传高清封面≥1280*720，有利于获得推荐</span>

                    <span>可选择以上封面。<span v-show="imgs.length > 4" @click="viewMore" class="dc cp">查看更多封面</span></span>
                </div>
            </div>
            <div class="el">
                <span class="label">视频标题:</span>
                <div class="pr">
                    <input v-model="title" class="input" type="text" maxlength="50" placeholder="请输入视频标题">
                    <p class="input-size">{{title.length}}/50</p>
                </div>
            </div>
            <div class="el">
                <span class="label">视频分类:</span>
                <el-select v-model="cate" multiple filterable placeholder="试试搜索: Popping" style="width: 450px" :multiple-limit="3">
                    <el-option v-for="v in cates" :key="v.id" :value="v.id" :label="v.name"></el-option>
                </el-select>
            </div>
            <div class="el">
                <span class="label">视频介绍:</span>
                <div class="pr">
                    <textarea v-model="digest" class="input textarea fl" maxlength="140" placeholder="填写更全面的信息, 让更多的人找到你的视频吧!"></textarea>
                    <p class="input-size">{{digest.length}}/50</p>
                </div>

            </div>
            <div class="el">
                <span class="label"></span>
                <div @click="submit" class="submit bg">
                    <div v-show="!is_loading">
                        <i class="icon-submit"></i>
                        立即发布
                    </div>
                    <div v-show="is_loading">
                        <i class="loading"></i>
                        正在发布
                    </div>
                </div>
                <div @click="draft" class="submit draft-btn">
                    <div v-show="!is_drafting">
                        <i class="icon-document"></i>
                        保存至草稿
                    </div>
                    <div v-show="is_drafting">
                        <i class="loading"></i>
                        正在保存中
                    </div>
                </div>
            </div>


        </div>
        <transition name="confirm-box">
            <div v-show="capture_show" class="capture-box">
                <transition name="confirm">
                    <div class="capture-main" v-show="capture_show">
                        <div class="capture-bar">
                            <span class="capture-title">更换封面</span>
                            <i @click="close" class="icon-close cp"></i>
                        </div>
                        <div ref="capture-content" class="capture-content">
                            <div class="capture-tab-box">
                                <span :class="`capture-tab${is_diy ? ' capture-tab-checked' : ''}`" @click="is_diy = true">自定义封面</span>
                                <span :class="`capture-tab${!is_diy ? ' capture-tab-checked' : ''}`" @click="is_diy = false">视频截图</span>

                            </div>
                            <div ref="capture-tailor-box" v-show="is_diy">
                                <div ref="capture-tailor" class="capture-tailor">
                                    <div @drop.prevent="coverDrop" @dragover.prevent @dragenter.prevent="modal_drag = true" @dragleave="coverDragleave" :class="modal_drag ? ' modal-drag' : ''">
                                        <label v-show="!cro.ready" for="upload-cover" :class="`capture-draw cp${modal_drag ? ' modal-drag' : ''}`">
                                            <i class="icon-image"></i>
                                            <br>
                                            点击选择图片
                                            <br>
                                            或将图片拖至此处
                                        </label>
                                        <div v-show="cro.ready">
                                            <img :src="diyCover" ref="cover" class="dn" alt="">
                                        </div>
                                    </div>

                                    <div class="capture-preview-box">
                                        <p>{{(!cro.ready && cover) ? '当前封面' : '封面预览'}}</p>
                                        <div ref="preview" class="capture-preview"></div>
                                    </div>
                                </div>
                                <label v-show="cro.ready" for="upload-cover" class="capture-again cp"><i class="icon-again"></i>点击此处或拖拽图片至上方进行更换</label>
                                <p v-show="!cro.ready" class="capture-tip">建议上传高清封面≥1280*720，有利于获得推荐</p>
                            </div>

                            <div v-show="!is_diy" class="capture-list">
                                <div v-for="(v, k) in imgs" :key="k" :class="`cover-list${k === checkIdx ? '' : ' cp'}`">
                                    <div class="cover-checked" v-show="k === checkIdx">
                                        <div class="cover-checked-icon">
                                            <i class="icon-success"></i>
                                        </div>
                                    </div>
                                    <div class="cover-mask" v-show="k !== checkIdx" @click="checkCover(k)" title="设置本图片为视频封面">
                                        设为封面
                                    </div>
                                    <img class="cover-img" :src="v" alt="">
                                </div>
                            </div>

                            <div class="btn-box">
                                <span class="capture-button bg" @click="captureSave">
                                    <span v-show="!cover_uploading" class="save-btn">完成</span>
                                    <span v-show="cover_uploading" class="save-btn loading"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>

        <video ref="video" @canplay="canplay" :src="blobSrc" class="dn" id="video" controls="controls"></video>
        <canvas ref="canvas" class="canvas dn"></canvas>
    </div>
</template>

<script>
    import 'cropperjs/dist/cropper.css';
    import Cropper from 'cropperjs';
    export default {
        data: () => ({
            is_first: true,// 是否为第一步
            is_drag: false,// 视频是否正在拖拽区域上方
            cover_drag: false,// 封面是否在拖拽区域上方
            modal_drag: false,// 模态框里的封面是否在拖拽区域上方
            imgs: [],
            imgFiles: [],// 保存封面blob
            checkIdx: 0,
            protoTitle: '',
            title: '',
            cates: [],
            cate: '',
            digest: '',
            is_loading: false,
            is_drafting: false,
            is_uploading: false,
            is_uploaded: false,
            cover: '',
            blobSrc: '',
            videoSrc: '',
            is_canplay: false,
            duration: 0,
            stream: null,
            capture_show: false,
            is_diy: false,
            cro: {},
            previewImg: null,
            diyCover: '',// 自定义的图片地址
            cover_uploading: false,// 封面上传中
            uploadProgress: 0,
            pk: 0,
        }),
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        methods: {
            dragleave(e) {// 视频拖拽离开
                if (e.relatedTarget === null || e.relatedTarget === this.$refs['upload-box']) {
                    this.is_drag = false;
                }
            },
            drop(e) {// 视频拖拽完成
                this.reader(e.dataTransfer);
            },
            change(e) {// 视频选择完成
                this.reader(e.target);
            },
            coverDragleave(e) {// 视频拖拽离开  related代表进入的元素
                if (e.relatedTarget === null || e.relatedTarget === this.$refs['capture-tailor-box'] || e.relatedTarget === this.$refs['capture-tailor'] || e.relatedTarget === this.$refs['capture-content']) {
                    this.modal_drag = false;
                }
            },
            coverChange(e) {// 封面选择完成
                this.coverReader(e.target);
            },
            coverDrop(e) {// 封面拖拽完成
                this.modal_drag = this.cover_drag = false;
                this.coverReader(e.dataTransfer);
            },
            close() {// 关闭截图层
                this.capture_show = false;
                this.$refs.coverInput.value = '';
            },
            viewMore() {// 查看更多截图
                this.capture_show = true;
                this.is_diy = false;
            },
            initCrop() {// 初始化截图工具
                let {cover, preview} = this.$refs;

                if (this.cro.ready || this.cover) {// 已初始化 则直接替换图片
                    this.cro.ready = true;
                    this.cro.replace(this.diyCover);
                    this.previewImg.src = this.diyCover;
                } else {// 进行初始化
                    this.cro = new Cropper(cover, {
                        aspectRatio: 16/9,
                        viewMode: 1,
                        zoomable: false,
                        // minCanvasHeight: 1000,
                        // minCanvasWidth: 1000,
                        minContainerWidth: 320,// 容器宽高
                        minContainerHeight: 180,
                        minCropBoxWidth: 1,
                        minCropBoxHeight: 1,
                        ready: () => {
                            let clone = cover.cloneNode();
                            clone.className = 'clone';
                            preview.appendChild(clone.cloneNode());
                            this.previewImg = preview.firstElementChild;// 对象引用 previewImg代表该元素
                            this.cro.setCropBoxData({width: 320, height: 180});// 设置初始裁剪框宽高后 会调用crop一次 完美解决初次选择图片时的定位问题
                        },

                        crop: e => {// 此方法在初始化时会先调用一次 但此时ready函数还没有运行 所以需要进行判断previewImg
                            let {detail} = e,
                                imageData = cover.cropper.getImageData(),
                                previewWidth = preview.offsetWidth,
                                imageScaledRatio = detail.width / previewWidth;

                            if (this.previewImg) {// 若已初始化 则直接改变style
                                this.previewImg.style.cssText = `width: ${imageData.naturalWidth / imageScaledRatio}px;height: ${imageData.naturalHeight / imageScaledRatio}px;transform: translateX(${-detail.x / imageScaledRatio}px) translateY(${-detail.y / imageScaledRatio}px);`;
                            }
                        },
                    });
                }
            },
            coverReader(target) {// 读取封面
                let reader = new FileReader, file = target.files[0];// 实例化FileReader对象

                if (file) {// 存在时文件流时执行
                    if (!file.type.includes('image')) return this.alert.err('请选择图片类型的文件');
                    if (file.size > 20000000) return this.alert.err('封面图片不可大于20M');
                    reader.readAsDataURL(file);
                    reader.onload = e => {
                        this.diyCover = e.target.result;
                        this.is_diy = true;
                        this.capture_show = true;
                        this.$nextTick(() => {
                            this.initCrop();
                        });
                    };
                }
            },
            reader(target) {// 读取视频
                let file = target.files[0];// 实例化FileReader对象

                if (file) {// 存在时文件流时执行
                    this.is_drag = false;
                    if (!file.type.includes('video')) return this.alert.err('请选择视频类型的文件');

                    if (file.size > 500000000) return this.alert.err('上传的视频不可大于500M');

                    this.blobSrc = URL.createObjectURL(file);
                    this.stream = file;
                }
            },

            async canplay(e) {// 获取视频截图
                if (this.is_canplay) return;
                this.is_canplay = true;
                this.duration = e.target.duration;

                let video = this.$refs['video'], i = 10, duration = this.duration - 1;
                if (duration < 4) this.alert.err('请上传5秒以上的视频');

                this.upload();
                this.play();

                for (i = 1; i < 9; i++) {
                    video.currentTime = duration / 8 * i;// 设置时间时会触发canplay
                    await this.getImg();
                }
            },
            getImg() {// 截取视频帧
                return new Promise(resolve => {
                    setTimeout(() => resolve(this.play()), 200)
                });
            },
            play() {// 生成截图
                let {canvas, video} = this.$refs;
                if (!canvas) return;
                canvas.getContext('2d').drawImage(video, 0, 0, 320, 180);
                this.imgs.push(canvas.toDataURL());
                canvas.toBlob(blob => {
                    this.imgFiles.push(blob);
                }, 'image/jpeg');
            },
            async upload() {// 上传视频
                this.is_first = false;
                let {name, type} = this.stream,
                    lastIdx = name.lastIndexOf('.'),
                    now = (new Date).toUTCString(),
                    {api} = this;

                this.is_uploading = true;
                this.protoTitle = name;
                this.title = name.substr(0, lastIdx);

                // 获取权限
                let auth = await api.put('users/videos/auth', {
                    now,
                    suffix: name.substr(lastIdx + 1, name.length),
                    type
                });

                // 上传视频至OSS
                try {
                    await api.putFile(api.videoHost + auth.key, auth.Authorization, now, this.stream, e => {
                        this.uploadProgress = ~~(e.loaded / e.total * 100);
                    });
                    // 添加视频记录至数据库 并返回主键id
                    this.pk = await api.post('users/videos/upload', {
                        src: api.videoHost + auth.key,
                        duration: this.duration * 1000
                    });
                } catch(e) {
                    this.alert.err('上传视频时发生错误, 请重新尝试');
                    this.$emit('reload');
                    // 将userId/123后面的部分 传给后台获取token
                    let key = auth.key.split(`users/${this.user.id}`)[1];
                    if (!key) return;

                    let delAuth = await api.del('users/videos/auth', {now, key});
                    api.delFile(api.videoHost + auth.key, delAuth.rawAuth, now);
                    api.delFile(api.videoOutputHost + auth.key, delAuth.outputAuth, now);
                }

                this.is_uploading = false;
                this.is_uploaded = true;
                this.uploadProgress = 0;
            },
            captureSave() {// 保存封面
                if (this.is_diy && this.cro.ready && !this.cover_uploading) {
                    this.cover_uploading = true;
                    try {
                        this.cro.getCroppedCanvas({maxWidth: 1920, maxHeight: 1080}).toBlob(this.put, 'image/jpeg');
                    } catch(e) {
                        this.cover_uploading = false;
                        this.alert.err('封面上传失败, 请重新尝试');
                    }
                }
                this.capture_show = false;
            },
            async put(blob) {// 上传视频封面
                let {api, user, cover} = this,
                    now = (new Date).toGMTString(),
                    {imgHost, imgCdn} = api,
                    authHost = 'users/auth', auth;

                auth = await api.put(authHost, {now});// 获取上传权限的token
                await api.putFile(imgHost + auth.key, auth.Authorization, now, blob);// 上传封面至OSS
                this.cover = imgCdn + auth.key;// 拼接图片CDN地址
                this.checkIdx = 9;// 取消截图选中
                this.cover_uploading = false;
                this.cro.ready = false;// 截图工具隐藏

                // 如果存在旧封面则删除旧封面
                if (cover) {
                    let key = cover.split(`users/${user.id}`)[1];// 获取userId/123后面的部分 传给后台获取code
                    auth = await api.del(authHost, {now, key});// 获取删除权限的token
                    api.delFile(`${imgHost}users/${user.id + key}`, auth.Authorization, now);
                }
            },
            async checkCover(k) {// 切换视频截图
                this.checkIdx = k;

                if (this.cover) {// 若已上传封面 则删除
                    let {cover, api, user} = this, now = (new Date).toGMTString();
                    this.cover = '';
                    if (this.cro.ready) {// 若已初始化 则销毁
                        this.$refs.preview.innerHTML = this.$refs.cover.nextElementSibling.outerHTML = '';
                        this.cro.destroy();// 销毁之前的实例才会运行ready
                    }

                    let key = cover.split(`users/${user.id}`)[1], auth;// 获取userId/123后面的部分 传给后台获取code
                    auth = await api.del('users/auth', {now, key});// 获取删除权限的token
                    api.delFile(`${api.imgHost}user/${user.id + key}`, auth.Authorization, now);
                }
            },
            async submit() {// 发布视频

                if (this.is_loading) {
                    return;
                }

                let {api, pk, cover, title, cate, digest} = this;

                if (title.length > 50) {
                    return this.alert.err('标题长度不能多于50字')
                }

                if (!cate.length) {
                    return this.alert.err('请选择视频分类');
                }

                if (digest.length > 250) {
                    return this.alert.err('视频描述最多250字');
                }

                this.is_loading = true;

                try {
                    if (!cover) {// 未上传自定义封面时的处理
                        let now = (new Date).toGMTString(), auth;
                        auth = await api.put('users/auth', {now});// 获取上传权限的token
                        await api.putFile(api.imgHost + auth.key, auth.Authorization, now, this.imgFiles[this.checkIdx]);// 上传封面至OSS
                        this.cover = cover = api.imgCdn + auth.key;
                    }
                    await api.patch(`users/videos/${pk}/upload`, {cover, title, cate: cate.join(','), digest});
                } catch(e) {
                    this.is_loading = false;
                    return this.alert.err('视频发布时发生错误, 请重新尝试');
                }

                this.$router.push('/users/manage?type=checking');
            },
            async draft() {// 保存为草稿
                let {api, pk, cover, title, cate, digest} = this;

                if (this.is_loading || this.is_drafting) {
                    return;
                }

                if (this.is_uploading) {
                    return this.alert.err('视频正在上传中, 请耐心等候');
                }

                if (title.length > 50) {
                    return this.alert.err('标题长度不能多于50字')
                }

                if (digest.length > 250) {
                    return this.alert.err('视频描述最多250字');
                }

                this.is_drafting = true;

                try {
                    if (!cover) {// 未上传自定义封面
                        if (!this.imgFiles.length) {
                            this.is_drafting = false;
                            return this.alert.err('请先上传视频封面');
                        }
                        let now = (new Date).toGMTString(), auth;
                        auth = await api.put('users/auth', {now});// 获取上传权限的token
                        await api.putFile(api.imgHost + auth.key, auth.Authorization, now, this.imgFiles[this.checkIdx]);// 上传封面至OSS
                        this.cover = cover = api.imgCdn + auth.key;
                    }
                    await api.patch(`users/videos/${pk}/draft`, {cover, title, cate: cate.join(','), digest});
                } catch(e) {
                    this.is_drafting = false;
                    return this.alert.err(e.message);
                }

                this.$router.push('/users/manage?type=draft');
            },
            back() {// 返回上一步
                if (this.is_first) return;
                this.confirm({
                    title: '返回上一步',
                    content: '是否要将已编辑的内容保存草稿箱？草稿箱最多只能保存24小时，请及时处理并发布。',
                    sure: '保存',
                    cancel: '不保存',
                    sureCb: () => {
                        this.is_first = true;
                    },
                    cancelCb: () => {
                        this.is_first = true;
                    }
                })
            },
        },
        beforeMount() {
            this.api.get('home/sorts').then(e => {
                this.cates = e;
            })
        },
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/upload.css";
</style>



// WEBPACK FOOTER //
// src/views/user/Upload.vue